/** @type {import("@mui/material").SxProps<typeof import('@mui/material/styles').Theme>} */
export const useStyles = (theme, leftLink) => ({
  appBar: {
    p: 0,
    background: theme?.palette?.default?.backgroundColor2,
    color: theme?.palette?.default?.textColor3,
  },
  mainNavStyle: {
    mainNavs: {
      display: 'flex',
      cursor: 'pointer',
      color: theme?.palette?.default?.textColor3,
      '& .MuiSvgIcon-root.dropdownIcon': {
        color: 'transparent',
      },
      '&:hover': {
        '& .MuiSvgIcon-root.dropdownIcon': {
          color: theme?.palette?.default?.textColor3,
        },
      },
      alignItems: 'center',
    },
    dropdownContainer: {
      position: 'absolute',
      top: '100px',
      left: '0',
      right: '0',
      zIndex: 5,
      backgroundColor: theme.palette.default.backgroundColor2,
      boxShadow: theme.palette.default.boxShadow1,
    },
    navLinkTitle: {
      py: 2,
      px: 1,
      cursor: 'text',
    },
    navLinks: {
      color: theme.palette.primary.textColor3,
      textDecoration: 'none',
      paddingTop: 1,
      paddingBottom: 1,
    },
  },

  subNavLinks: {
    p: '8px 16px',
    textDecoration: 'none',
    color: theme.palette.default.textColor3,
  },
  imageContainer: {
    p: 1,
    pl: 2,
  },
  topLeftNavs: {
    color: theme.palette.primary.textColor3,
    p: leftLink ? '8px 24px ' : 1,
  },
  topNavMain: { mr: leftLink ? 1 : 0, pl: leftLink ? 0 : 3 },
  topNavTitle: {
    p: leftLink ? '8px 24px ' : 1,
  },
  topNav: {
    p: leftLink ? '8px 24px ' : 1,
    background: theme.palette.default.backgroundColor2,
  },
  navTitle: {
    fontFamily: theme.typography.h5.fontFamily,
    fontWeight: theme.typography.h5.fontWeight,
    fontSize: theme.typography.h5.fontSize,
    lineHeight: theme.typography.h5.lineHeight,
    '@media (max-width: 600px)': {
      fontSize: '1.069rem',
      lineHeight: '1.75rem',
    },
  },
  solidctastyle: {
    border: `0.063rem solid ${theme.palette.primary.textColor2}`,
    // width: '212px',
    // padding: '0.3125rem',
    padding: '8px 22px',
    margin: '16px 0 9px 0',
    // height: '40px',

    color: theme.palette.secondary.contrastText,
    background: theme.palette.primary.buttonColor,
    '&:hover': {
      border: `0.063rem solid ${theme.palette.primary.textColor2}`,
      background: theme.palette.primary.buttonPrimaryHoverColor,
      color: theme.palette.primary.contrastText,
      boxShadow: `0px 4px 45px -9px ${theme.palette.primary.boxShadow1Darkest}`,
    },
    [theme.breakpoints.down('md')]: {
      marginLeft: '0.5rem',
    },
    // Hidden visually until focused
    position: 'absolute',
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    //  width: 1,
    //  height: 1,
    overflow: 'hidden',
    whiteSpace: 'nowrap',

    '&:focus-visible': {
      position: 'static',
      clip: 'auto',
      clipPath: 'none',
      width: 'auto',
      height: 'auto',
      //  padding: '8px 12px',
      outline: '3px solid #DD1D78',
      outlineOffset: '3px',
      //  mb: 1,
    },
  },
});
